import { Button, Classes, Dialog, FormGroup, InputGroup, Intent } from '@blueprintjs/core'
import { UserProfile } from 'common/typings'
import { FormFields, lang, toast } from 'enablex/shared'
import React, { FC, useEffect, useState } from 'react'
import api from '~/app/api'
import UserIcon from '~/icons/UserIcon'

interface Props {
  isOpen: boolean
  profile: UserProfile
  toggle: () => void
  fetchProfile: () => void
}

const UpdateUserProfile: FC<Props> = props => {
  const [firstname, setFirstname] = useState<string>()
  const [lastname, setLastname] = useState<string>()
  const [picture_url, setPictureUrl] = useState<string>()
  const [isFirstNameValid, setIsFirstNameValid] = useState<boolean>(true)
  const [isLastNameValid, setIsLastNameValid] = useState<boolean>(true)

  const isOnlySpecialCharacter = (input) => {
    // Regular expression to check if the bot name consists only of special characters
    const specialCharOnlyRegex = /^[^a-zA-Z0-9]*$/
    if (specialCharOnlyRegex.test(input)) {
      return true
    }
    return false
  }
  const isValidName = (value) => {
    // Check if the bot name consists only of special characters
    if (isOnlySpecialCharacter(value)) {
      return false
    }

    const regex = /^[a-z0-9\(\)_-\s]+$/i
    if(!regex.test(value)) {
      return false
    }

    return true
  }

  useEffect(() => {
    setFirstname(props.profile.firstname)
    setLastname(props.profile.lastname)
    setPictureUrl(props.profile.picture_url)
  }, [props.isOpen])

  const submit = async event => {
    event.preventDefault()

    try {
      await api.getSecured().post('/admin/user/profile', { firstname, lastname, picture_url })

      props.fetchProfile()
      props.toggle()

      toast.success(lang.tr('admin.profileUpdatedSuccessfully'))
    } catch (err) {
      toast.failure(lang.tr('admin.errorUpdatingProfile', { msg: err.message }))
    }
  }

  const uploadFieldChange = (url: string | undefined) => {
    setPictureUrl(url)
  }

  const v1Client = api.getSecured({ useV1: true })

  return (
    <Dialog
      title={lang.tr('admin.updateYourProfile')}
      icon={<UserIcon />}
      isOpen={props.isOpen}
      onClose={props.toggle}
      transitionDuration={0}
      canOutsideClickClose={false}
    >
      <form onSubmit={submit}>
        <div className={Classes.DIALOG_BODY}>
          <FormGroup helperText={'First name must not contain more than 35 alphanumerical characters. Only those special characters are accepted: (, ), -, _, and spaces)'} label={lang.tr('admin.firstName')} labelFor="input-firstname">
            <InputGroup
              id="input-firstname"
              value={firstname}
              maxLength={35}
              onChange={e => {
                const value = e.target.value
                if (isValidName(value)) {
                  setIsFirstNameValid(true)
                } else {
                  setIsFirstNameValid(false)
                }
                setFirstname(value)
              }}
              tabIndex={1}
              autoFocus={true}
            />
          </FormGroup>

          <FormGroup helperText={'Last name(must not contain more than 35 alphanumerical characters. Only those special characters are accepted: (, ), -, _, and spaces)'} label={lang.tr('admin.lastName')} labelFor="input-lastname">
            <InputGroup
              id="input-lastname"
              value={lastname}
              maxLength={35}
              onChange={e => {
                const value = e.target.value
                if (isValidName(value)) {
                  setIsLastNameValid(true)
                } else {
                  setIsLastNameValid(false)
                }
                setLastname(value)
              }}
              tabIndex={2}
            />
          </FormGroup>
            <FormGroup label={lang.tr('admin.profilePicture')}>
            <FormFields.Upload axios={v1Client} onChange={uploadFieldChange} value={picture_url} type="image" />
            <span style={{ fontSize: '12px', marginTop: '5px', fontWeight: 'bold' }}>        Max size: 200kb       </span>
            </FormGroup>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              id="btn-submit-update-user"
              type="submit"
              text={lang.tr('save')}
              tabIndex={3}
              intent={Intent.PRIMARY}
              disabled={!isFirstNameValid || !isLastNameValid}
            />
          </div>
        </div>
      </form>
    </Dialog>
  )
}

export default UpdateUserProfile
